import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LoginViewEnum } from '../components/login-view.enum';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  currentLoginView$: BehaviorSubject<LoginViewEnum> = new BehaviorSubject(
    LoginViewEnum.LOGIN
  );

  public changeLoginView(loginView: LoginViewEnum): void {
    this.currentLoginView$.next(loginView);
  }
}
